import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, CardBody, Row, Col, Badge } from "shards-react";

const UserDetails = () => {
  const [userData, setUserData] = useState({
    coverImg: require("../../images/user-profile/up-user-details-background.jpg"),
    avatarImg: require("../../images/avatars/fav.png"),
    name: "",
    bio: "Focused on providing secure app solutions.",
    email: "",
    location: "",
    phone: "",
    accNumber: "",
    tags: []
  });

  useEffect(() => {
    // Retrieve user data from localStorage
    const userDataFromStorage = {
      email: localStorage.getItem("email_id") || "", // email_id for Email
      company: localStorage.getItem("company_name") || "", // company_name for Organization
      userid: localStorage.getItem("user_id") || "", // user_id for User ID
      company_id: localStorage.getItem("company_id") || "", // company_id

      licence_key: localStorage.getItem("LicenceKey") || "", // company_id

      tags: JSON.parse(localStorage.getItem("packages") || "[]") // packages in JSON format as an array for tags
    };

    setUserData((prevData) => ({
      ...prevData,
      name: userDataFromStorage.company,
      email: userDataFromStorage.email,
      location: userDataFromStorage.company,
      phone: userDataFromStorage.userid,
      accNumber: userDataFromStorage.company_id,
      licence:userDataFromStorage.licence_key,
      tags: userDataFromStorage.tags
    }));
  }, []);

  return (
    <Card small className="user-details mb-4 shadow-sm border-0 rounded-lg mt-2">
      <CardHeader className="p-0">
        <div className="user-details__bg position-relative">
          <img src={userData.coverImg} alt={userData.name} className="user-details__bg-img" />
          <div className="overlay" />
        </div>
      </CardHeader>
      <CardBody className="p-0">
        <div className="user-details__avatar mx-auto mt-n5">
          <img src={userData.avatarImg} alt={userData.name} className="rounded-circle border border-white shadow" />
        </div>
        <h4 className="text-center font-weight-bold mt-3 mb-1">{userData.name}</h4>
        <p className="text-center text-muted small">{userData.bio}</p>

        <div className="user-details__user-data border-top border-bottom p-3">
          <Row className="text-center">
            <Col>
              <strong>Email:</strong>
              <p className="text-muted">{userData.email}</p>
            </Col>
            <Col>
              <strong>Organization:</strong>
              <p className="text-muted">{userData.location}</p>
            </Col>
          </Row>
          <Row className="text-center">
            <Col>
              <strong>User ID:</strong>
              <p className="text-muted">{userData.phone}</p>
            </Col>
            <Col>
              <strong>Company ID:</strong>
              <p className="text-muted">{userData.accNumber}</p>
            </Col>
          </Row>

          {userData.licence && (
  <Row className="text-center">
    <Col>
      <strong>Licence Key:</strong>
      <p className="text-muted">{userData.licence}</p>
    </Col>
  </Row>
)}




        </div>

        <div className="p-3 text-center">
          {userData.tags.map((tag, idx) => (
            <Badge key={idx} pill className="text-uppercase mx-1 mb-1" theme="info">
              {tag}
            </Badge>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

UserDetails.propTypes = {
  userData: PropTypes.object
};

export default UserDetails;
